
const categories = [
    {
        id: 1,
        name: 'standard',
        value: 'standard',
    },
    {
        id: 2,
        name: 'comfort',
        value: 'comfort',
    },
    {
        id: 3,
        name: 'senior',
        value: 'senior',
    },
]
export default categories